import {useGetCouponCodeReport} from '../hooks/useGetCouponCodeReport'
import {CouponCodeReportContext} from '../context'
import {KTCard} from '../../../_metronic/helpers'
import CouponCodeReportTable from '../sections/table/CouponCodeReportTable'
import CouponCodeReportHeader from '../sections/header/CouponCodeReportHeader'
import {Pagination} from '../../../utils/pagination'
import useGetEntityPerformanceChartData from '../hooks/useGetEntityPerformanceChartData'

function CouponCodeReport() {
  const {
    reportData,
    isLoading,
    filters,
    onSearch,
    onSortingChange,
    onPageChange,
    handleCouponCodeReportDateChange,
    pagination,
    onDownloadCsv,
  } = useGetCouponCodeReport()

  const {
    entityPerformanceChartData,
    isLoading:isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,
  } = useGetEntityPerformanceChartData('coupon_code')

  const contextValue = {
    reportData,
    isLoading,
    filters,
    onSearch,
    onSortingChange,
    onPageChange,
    handleCouponCodeReportDateChange,
    pagination,
    onDownloadCsv,  

    entityPerformanceChartData,
    isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,
  }

  return (
    <KTCard>
      <CouponCodeReportContext.Provider value={contextValue}>
        <CouponCodeReportHeader />
        <CouponCodeReportTable />
        <Pagination pagination={pagination} onPageChange={onPageChange} />
      </CouponCodeReportContext.Provider>
    </KTCard>
  )
}

export default CouponCodeReport
